import { useEffect, useState } from 'react';
import { fetchStateList } from '../_api';
import AppWrappedSelect from 'pages/ApplicationRequest/components/containers/AppWrappedSelect';
import { LINK_FIELD_KEYS } from '../_const';

const StateField = ({ formik }) => {
	const [sOptions, setOptions] = useState(null);

	useEffect(() => {
		let active = true;

		async function fetchApi() {
			//fetch the base job category info
			const stateData = await fetchStateList();

			//TODO - massage the data
			const stateOptions = stateData.map(s => {
				return {
					key: s.Key,
					displayValue: s.Value,
					value: s.Key,
				};
			});
			//set the state
			setOptions(stateOptions);
		}

		if (active) {
			fetchApi();
		}
		if (active) {
			setOptions([]);
		}

		return () => {
			active = false;
		};
	}, []);

	return (
		<AppWrappedSelect
			name={LINK_FIELD_KEYS.LICENSE_STATE}
			isRequired
			label='License State'
			formik={formik}
			options={sOptions}
			helperText='License State is required based on the job category you selected.'
		/>
	);
};

export default StateField;
